import { render } from "./IconWarningCircle.vue?vue&type=template&id=05910aed"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconWarningCircle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05910aed"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05910aed', __exports__)) {
    api.reload('05910aed', __exports__)
  }
  
  module.hot.accept("./IconWarningCircle.vue?vue&type=template&id=05910aed", () => {
    api.rerender('05910aed', render)
  })

}


export default __exports__